<template>
	<sa-page-layout :btnSaveVisible="true" :pathResource="pathResource" :data="documentoJsonData"
		:btnRouterBackVisible="true" :linkSaveAndClose="'/contabilita/documenti'" @beforeSave="onBeforeSave"
		@afterSave="onAfterSave" :userinfo="!!documentoJsonData.primaryKey">
		<!-- <template slot="toolbar"> <b-alert show>Default Alert</b-alert> </template> -->
		<template slot="toolbar">
			<b-button v-if="isBtnDocumentiCollegatiVisibile" :disabled="isBtnDocumentiCollegatiDisabled"
				variant="purple btn-toolbar float-sm-left sa-margin-left" style="margin-right: 5px" size="sm"
				@click="onClickDocumentiCollegati"><b-icon icon="check2"></b-icon>Documenti Collegati</b-button>
		</template>
		<template slot="table-header">
			<contabilita-documento-dati-edit-compontent ref="cmpContabilitaDocumentoDatiEditCompontent"
				@update="onUpdateContabilitaDocumentoDatiEditCompontent"
				@resetJsonDataDestinazioneRigheDocumento="onResetJsonDataDestinazioneRigheDocumento" />
		</template>
		<template slot="table-body">
			<b-tabs content-class="mt-3" class="sa-tab" style="height: 100%" fill @input="onInputTabs">
				<b-tab title="Righe Documento" active>
					<contabilita-documento-righe-component :jsonData="documentoJsonData"
						@update="onUpdateContabilitaRigheDocumento" ref="cmpContabilitaDocumentoRigheComponent" />
				</b-tab>
				<b-tab title="Riepilogo" :disabled="documentoJsonData.righeDocumento == 0">
					<contabilita-riepilogo-component ref="cmpContabilitaDocumentoRiepologoComponent" />
				</b-tab>

				<!-- :disabled="isDocumentiCollegatiDisabled()" -->
				<b-tab v-if="isBtnDocumentiCollegatiVisibile" :disabled="isBtnDocumentiCollegatiDisabled"
					title="Documenti Collegati">
					<ContabilitaDocumentiCollegatiComponent ref="cmpContabilitaDocumentiCollegatiComponent" />
				</b-tab>
			</b-tabs>
		</template>
		<template slot="table-footer">
			<contabilita-documenti-collegati-modal @updateDocumentiRiferimento="onUpdateDocumentiRiferimento"
				ref="mdlContabilitaDocumentiCollegatiModal" />
			<div class="sa-ft-contabilita-footer-modern">
				<div class="sa-ft-total-card">
					<span class="sa-ft-label">📊 Imponibile : </span>
					<span class="sa-ft-value">{{ imponibile.toFixed(2) }} €</span>
				</div>

				<div class="sa-ft-total-card">
					<span class="sa-ft-label">🧾 IVA : </span>
					<span class="sa-ft-value">{{ iva.toFixed(2) }} €</span>
				</div>

				<div class="sa-ft-total-card highlight">
					<span class="sa-ft-label" style="color:whitesmoke">💰 TOTALE : </span>
					<span class="sa-ft-value" style="color:whitesmoke">{{ totale.toFixed(2) }} €</span>
				</div>
			</div>
		</template>
	</sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import StruttureMixin from "../../strutture/mixins/StruttureMixin";
import UtilityMixin from "../../utility/UtilityMixin.js";
import ContabilitaDocumentoDatiEditCompontent from "../components/ContabilitaDocumentoDatiEditCompontent.vue";
import ContabilitaDocumentoRigheComponent from "../components/ContabilitaDocumentoRigheEditComponentN.vue";
import ContabilitaRiepilogoComponent from "../components/ContabilitaRiepilogoComponent.vue";
import ContabilitaDocumentiCollegatiModal from "../components/ContabilitaDocumentiCollegatiModal.vue";
import ContabilitaDocumentiCollegatiComponent from "../components/ContabilitaDocumentiCollegatiComponent.vue";
import ContabilitaMixin from "../mixins/ContabilitaMixin";
import MagazzinoMixins from "../../magazzino/mixins/MagazzinoMixins";

//import DatePicker from "vue2-datepicker";
export default {
	components: { SaPageLayout, ContabilitaDocumentoDatiEditCompontent, ContabilitaDocumentoRigheComponent, ContabilitaDocumentiCollegatiComponent, ContabilitaRiepilogoComponent, ContabilitaDocumentiCollegatiModal },
	mixins: [UtilityMixin, StruttureMixin, ContabilitaMixin, MagazzinoMixins],
	data() {
		return {
			id: "-1",
			pathResourceCalcoloDocumento: "/contabilitadocumenti/calcola",
			pathResource: "/contabilitadocumenti",
			pathResourceContabilitaCausaleDocumento: "/contabilitadocumentocausali/",
			causaleSelezionata: null,
			keyRigheDocumento: 0,
			isBtnDocumentiCollegatiVisibile: false,
		};
	},
	computed: {
		isBtnDocumentiCollegatiDisabled: function () {
			if (this.documentoJsonData.soggettoId == null || this.documentoJsonData.soggettoId == "-1" || this.documentoJsonData.soggettoCognomeRagione == null) {
				return true;
			}
			return false;
		},
		isMagazzinoObbligatorio: function () {
			if (this.documentoJsonData.causaleDocumentoOperazioneMagazzino != null && this.documentoJsonData.causaleDocumentoOperazioneMagazzino != 0 && this.documentoJsonData.magazzinoId == null) {
				return true;
			}
			return false;
		},
		imponibile() {
			return this.documentoJsonData.documentoTotaleImponibile;
		},
		iva() {
			return this.documentoJsonData.documentoTotaleImposta;
		},
		totale() {
			return this.documentoJsonData.documentoTotale;
		},
	},
	watch: {
		"documentoJsonData.causaleDocumentoId": function (params) {
			this.loadDataCausale(params);
		},
	},
	mounted() {
		this.id = this.$route.params.id;
		if (this.id && this.id != "-1") {
			this.loadData();
		}
		this.init();
	},
	methods: {
		init() {
			this.$refs.cmpContabilitaDocumentoDatiEditCompontent.init(this.documentoJsonData);
			this.$refs.cmpContabilitaDocumentoRigheComponent.init(this.documentoJsonData);
			this.$refs.cmpContabilitaDocumentoRiepologoComponent.init(this.documentoJsonData);
		},

		onResetJsonDataDestinazioneRigheDocumento() {
			this.documentoJsonData = { ...this.documentoJsonData, ...this.documentoJsonDataDestinazione };
			this.documentoJsonData.righeDocumento = [];
			this.documentoJsonData.righeDocumento = [];
			this.documentoJsonData.righeDocumentoIva = [];
			this.documentoJsonData.righePagamenti = [];
			this.documentoJsonData.documentiCollegati = [];
			this.$refs.cmpContabilitaDocumentoDatiEditCompontent.init(this.documentoJsonData);
			this.$refs.cmpContabilitaDocumentoRigheComponent.init(this.documentoJsonData);
			this.$refs.cmpContabilitaDocumentoRiepologoComponent.init(this.documentoJsonData);
		},
		onBeforeSave() {
			this.mangazzinoArticoliUnitaMisuraLoadData();
			this.prepareJsonData();
		},
		onAfterSave() {
			this.$router.push("/contabilita/documenti");
		},
		onUpdateContabilitaDocumentoDatiEditCompontent(jsonData) {
			this.documentoJsonData = { ...jsonData };
		},
		onInputTabs(value) {
			switch (value) {
				case 0:
					this.$refs.cmpContabilitaDocumentoRigheComponent.init(this.documentoJsonData);
					break;
				case 1:
					this.$refs.cmpContabilitaDocumentoRiepologoComponent.init(this.documentoJsonData);
					break;
				case 2:
					this.$refs.cmpContabilitaDocumentiCollegatiComponent.init(this.documentoJsonData, this.causaleSelezionata);
					break;
				default:
					break;
			}
		},
		onUpdateContabilitaRigheDocumento(righeDocumento) {
			this.documentoJsonData.righeDocumento = [...righeDocumento];
			this.calcolaDocumentoRigaDocumento();
		},
		calcolaDocumentoRigaDocumento() {
			let link = process.env.VUE_APP_PATH_API + this.pathResourceCalcoloDocumento;
			this.prepareJsonData();
			UtilityMixin.methods.restCallPost(link, this.documentoJsonData, this.calcolaDocumentoRigaDocumentoSuccess, this.calcolaDocumentoRigaDocumentoError);
		},
		prepareJsonData() {
			delete this.documentoJsonData._showDetails;
			this.documentoJsonData.righeDocumento.forEach((e) => {
				delete e._showDetails;
				delete e.totaleRiga;
				e.sconto = e.sconto / 100;
				if (e.lottiScadenze.length > 0) {
					e.lottiScadenze.forEach((e) => {
						delete e.giacenza;
					});
				}
			});
		},
		// Il backend lavora/persiste lo sconto come frazione (0-1), mentre l'interfaccia
		// (form riga e visualizzazione) usa sempre una percentuale (0-100). Ogni volta che
		// arrivano righeDocumento dal backend vanno riportate in percentuale.
		normalizzaScontoRigheDocumento(righeDocumento) {
			(righeDocumento || []).forEach((e) => {
				if (e.sconto != null) e.sconto = e.sconto * 100;
			});
		},
		calcolaDocumentoRigaDocumentoSuccess(response) {
			this.documentoJsonData = response.data.data;
			this.normalizzaScontoRigheDocumento(this.documentoJsonData.righeDocumento);
			this.init();
		},
		calcolaDocumentoRigaDocumentoError(error) {
			error;
		},
		loadData() {
			UtilityMixin.methods.loadDataResources(this.pathResource + "/" + this.id, {}, this.loadDataSuccess, this.loadDataError);
		},
		loadDataSuccess(response) {
			this.contabilitaSetJsonData(response.data.data);
			this.normalizzaScontoRigheDocumento(this.documentoJsonData.righeDocumento);
			this.init();
		},
		loadDataError(error) {
			console.log(error);
		},

		loadDataCausale(idCausale) {
			UtilityMixin.methods.loadDataResources(this.pathResourceContabilitaCausaleDocumento + idCausale, {}, this.loadDataCausaleSuccess, this.loadDataCausaleError);
		},
		loadDataCausaleSuccess(response) {
			this.causaleSelezionata = response.data.data;
			this.isBtnDocumentiCollegatiVisibile = this.causaleSelezionata.documentiCollegati.length > 0;
		},
		loadDataCausaleError(error) {
			console.log(error);
		},
		onUpdateDocumentiRiferimento(documentiRiferimento, righeDocumentiRiferimenti) {
			this.documentoJsonData.documentiCollegati = documentiRiferimento;
			let arrayRigheDocumento = [];
			for (let documento in righeDocumentiRiferimenti) {
				for (let riga of righeDocumentiRiferimenti[documento]) {
					let riferimentoDoc = documentiRiferimento.filter((e) => e.idDocumentoRiferimento == documento);
					riga.documentoRiferimentoRigaId = riga.id;
					riga.id = null;
					riga.documentoRiferimentoId = documento;
					riga.documentoRiferimentoDescrizione = riferimentoDoc[0].documentoRiferimentoDescrizione;
					riga.documentoRiferimentoRigaQuantita = riga.quantita;
					arrayRigheDocumento.push(riga);
				}
			}
			this.normalizzaScontoRigheDocumento(arrayRigheDocumento);
			this.documentoJsonData.righeDocumento = [...arrayRigheDocumento];
			this.calcolaDocumentoRigaDocumento();
			this.init();
			this.$refs.mdlContabilitaDocumentiCollegatiModal.hide();
		},

		onClickDocumentiCollegati() {
			this.$refs.mdlContabilitaDocumentiCollegatiModal.init(this.documentoJsonData, this.causaleSelezionata);
		},
	},
};
</script>
<style scoped>
.sa-ft-contabilita-footer-modern {
	display: flex;
	justify-content: space-between;
	padding: 10px;
	background-color: #f8f9fa;
	border-top: 2px solid #dee2e6;
}

.sa-ft-total-card {
	background: #ffffff;
	padding: 6px 8px;
	border-radius: 8px;
	border: 1px solid #e0e0e0;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
	display: inline;
	text-align: right;
}

.sa-ft-total-card .label {
	font-size: 0.7rem;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 1px;
	white-space: nowrap;
}

.sa-ft-total-card .value {
	font-size: 1rem;
	font-weight: 700;
	color: #333;
}

.sa-ft-total-card.highlight {
	background-color: #007bff;
	border-color: #0069d9;
}

.sa-ft-total-card.highlight .label {
	color: rgba(255, 255, 255, 0.8);
}

.sa-ft-total-card.highlight .value {
	color: #ffffff;
	font-size: 1.1rem;
}
</style>
